import { IAdpVoucherHolder } from "./adp-voucher-holder";

export interface IAdpVoucherHolderGetResponse {
    data: {
        success: boolean;
        message: string;
        results: IAdpVoucherHolder[];
    }
}